import styled from "styled-components";

const SelectStyled = styled.div`
  display: flex;
  flex-direction: column;

  .rs__control,
  rs__control:hover {
    border: 1px solid ${(p) => p.theme.color.primary.xlight} !important;
    border-radius: 8px;
    box-shadow: unset;
    height: 44px;
  }

  .rs__control--is-disabled {
    background-color: #eee;
  }

  .rs__single-value--is-disabled {
    color: ${(p) => p.theme.color.neutral.base};
  }

  p {
    margin-top: 5px;
    margin-bottom: 0px;
  }
`;

export default SelectStyled;
